module.exports = __webpack_public_path__ + "static/media/jenni-lee-icon.69030206.jpg";